import { render, staticRenderFns } from "./v-locale.pug?vue&type=template&id=00d08ed3&lang=pug&"
import script from "./v-locale.vue?vue&type=script&lang=js&"
export * from "./v-locale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports